import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Grid,
  Avatar,
  Typography,
  Divider,
  useMediaQuery,
  useTheme,
  Paper,
  Button,
} from "@mui/material";
import { tokens } from "../components/Theme";
import { useNavigate } from "react-router-dom";
import GetFarmer from "../api/farmer/GetFarmer";

function UserData() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const userData = JSON.parse(localStorage.getItem("userdata"));
  const imageUrl = `${process.env.REACT_APP_STORAGE_URL}pea-daily/Farmer/${userData.appFarmerId}.png`;
  const [avatarSrc, setAvatarSrc] = useState(imageUrl);
  const [userInfo, setUserInfo] = useState({
    title: "นาย",
    firstName: "เอกรัตน์",
    lastName: "พิทบวรษศักดิ์",
    gender: "ชาย",
    dateOfBirth: "31/03/2545",
    idCard: "1101100247596",
    idCardExpiryDate: "31/03/2570",
    addr: "แอสการ์ด",
    province: "เมืองทองคำ",
    amphur: "เกต 2",
    tambon: "วังต้องห้าม 01",
    postCode: "888",
    email: "bbekoraty@gmail.com",
    registrationNumber: "888888",
    registrationType: "Senior Furniture",
    lineId: "888",
    mobileNo: "+66 615018999",
  });
  const navigate = useNavigate();

  const handleSubmit = () => {
    navigate("/farmerInfo");
  };

  const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    if (isNaN(d)) return date; 
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    setAvatarSrc(imageUrl);
  }, [userData.appFarmerId]);
  useEffect(() => {
    const fetchFarmerData = async () => {
      try {
        const response = await GetFarmer({ appFarmerId: userData.appFarmerId });
        setUserInfo({
          ...response,
          dateOfBirth: response.dateOfBirth ? new Date(response.dateOfBirth) : null,
          idCardExpiryDate: response.idCardExpiryDate ? new Date(response.idCardExpiryDate) : null,
        });
      } catch (error) {
        console.error("Error fetching farmer data:", error);
      }
    };
    fetchFarmerData();
  }, []);

  return (
    <Box sx={{ padding: isMobile ? 2 : 4, margin: "auto" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 4 }}>
        <Avatar
          alt={userInfo.firstName}
          src={avatarSrc}
          onError={() => setAvatarSrc(null)}
          sx={{
            width: 80,
            height: 80,
            bgcolor: "primary.main",
            fontSize: 32,
          }}
        >
          {userInfo.firstName?.[0] || ""}
        </Avatar>
        <Box>
          <Box display="flex">
            <Typography variant={isMobile ? "h6" : "h4"} fontWeight="bold" noWrap>
              {userInfo.title}
            </Typography>
            <Typography variant={isMobile ? "h6" : "h4"} fontWeight="bold" ml="5px" noWrap>
              {userInfo.firstName}
            </Typography>
            <Typography variant={isMobile ? "h6" : "h4"} fontWeight="bold" ml="5px" noWrap>
              {userInfo.lastName}
            </Typography>
          </Box>
          <Typography variant="body1" color="text.secondary">
            เกษตรกร
          </Typography>
        </Box>
      </Box>

      <Paper elevation={1} sx={{ mb: 3, p: 2, borderRadius: 2 }}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          ข้อมูลส่วนตัว
        </Typography>
        <Divider sx={{ mb: 1 }} />
        <Typography variant="body1"><strong>เพศ:</strong> {userInfo.gender}</Typography>
        <Typography variant="body1"><strong>เลขบัตรประชาชน:</strong> {userInfo.idCard}</Typography>
        <Typography variant="body1"><strong>วันเดือนปีเกิด:</strong> {formatDate(userInfo.dateOfBirth)}</Typography>
        <Typography variant="body1"><strong>วันหมดอายุบัตร:</strong> {formatDate(userInfo.idCardExpiryDate)}</Typography>
      </Paper>

      <Paper elevation={1} sx={{ mb: 3, p: 2, borderRadius: 2 }}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          ข้อมูลติดต่อ
        </Typography>
        <Divider sx={{ mb: 1 }} />
        <Typography variant="body1"><strong>อีเมล:</strong> {userInfo.email}</Typography>
        <Typography variant="body1"><strong>เบอร์โทร:</strong> {userInfo.mobileNo}</Typography>
        <Typography variant="body1"><strong>ไอดีไลน์:</strong> {userInfo.lineId}</Typography>
      </Paper>

      <Paper elevation={1} sx={{ mb: 3, p: 2, borderRadius: 2 }}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          ที่อยู่อาศัย
        </Typography>
        <Divider sx={{ mb: 1 }} />
        <Typography variant="body1"><strong>ที่อยู่:</strong> {userInfo.addr}</Typography>
        <Typography variant="body1"><strong>จังหวัด:</strong> {userInfo.province}</Typography>
        <Typography variant="body1"><strong>อำเภอ:</strong> {userInfo.amphur}</Typography>
        <Typography variant="body1"><strong>ตำบล:</strong> {userInfo.tambon}</Typography>
        <Typography variant="body1"><strong>รหัสไปรษณีย์:</strong> {userInfo.postCode}</Typography>
      </Paper>

      <Paper elevation={1} sx={{ mb: 3, p: 2, borderRadius: 2 }}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          ทะเบียนเกษตรกร
        </Typography>
        <Divider sx={{ mb: 1 }} />
        <Typography variant="body1"><strong>เลขทะเบียนเกษตรกร:</strong> {userInfo.registrationNumber}</Typography>
        <Typography variant="body1"><strong>ประเภทสมาชิก:</strong> {userInfo.registrationType}</Typography>
      </Paper>

      <Box p="20px" display="flex" justifyContent="flex-end">
        <Button
          variant="contained"
          sx={{ bgcolor: colors.yellowAccent[500], color: "#000", borderRadius: "15px" }}
          onClick={handleSubmit}
        >
          แก้ไขข้อมูล
        </Button>
      </Box>
    </Box>
  );
}

export default UserData;
